export default {"src":"/_next/static/image/public/images/flags/flag_251.afa7273d618919dc1d95e710dfcb36cc.svg","height":16,"width":25};